import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paket-data',
  templateUrl: './paket-data.component.html',
  styleUrls: ['./paket-data.component.css']
})
export class PaketDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
